module.exports = __webpack_public_path__ + "static/media/dream.75c4d2ae.png";